import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '70%',
        margin: '0 auto',
    },
    tableRow: {
        fontSize: '12pt',
    },
    link: {
        color: '#0000EE',
        textDecoration: 'inherit',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
});

const tabNames = ['Windows', 'Mac', 'Linux'];

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: props.padding ? 8 * 3 : 0 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    padding: PropTypes.bool,
};

const CustomTableCell = withStyles(theme => ({
    body: {
        fontSize: 14,
    },
}))(TableCell);

class VdeDatasetViewerDownloadsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTab: 0,
        };
    }

    handleChange = (attName) => (event, value) => {
        this.setState({
            [attName]: value,
        });
    }

    getDownloadsTable = (data, version) => {
        return (
            <Table>
                <TableBody>
                    {data.map((row, index) => {
                        const { link, description } = row;
                        return (
                            <TableRow key={index} className={this.props.classes.tableRow}>
                                <CustomTableCell>{description}</CustomTableCell>
                                <CustomTableCell>
                                    <a
                                        href={'https://github.com/defineEditor/vde-dataset-viewer/releases/download/v' +
                                            encodeURIComponent(version) + '/' + encodeURIComponent(link)
                                        }
                                        target='_blank' rel='noopener noreferrer'
                                    >
                                        {link}
                                    </a>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <a
                                        href={'https://github.com/defineEditor/vde-dataset-viewer/releases/tag/v' + version}
                                        target='_blank' rel='noopener noreferrer'
                                        className={this.props.classes.link}
                                    >
                                        Release Notes
                                    </a>
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }

    render() {
        const { classes, currentVersion } = this.props;

        let downloads = {
            Windows: [
                {
                    description: 'Installer (64-bit)',
                    link: 'vde-dataset-viewer.Setup.' + currentVersion + '.exe'
                },
                {
                    description: 'Portable Version (64-bit)',
                    link: 'vde-dataset-viewer.' + currentVersion + '.exe'
                },
            ],
            Mac: [
                {
                    description: 'Installer (64-bit)',
                    link: 'vde-dataset-viewer-' + currentVersion + '.dmg'
                },
                {
                    description: 'Installer (arm64)',
                    link: 'vde-dataset-viewer-' + currentVersion + '-arm64.dmg'
                },
            ],
            Linux: [
                {
                    description: 'AppImage',
                    link: 'vde-dataset-viewer.' + currentVersion + '.AppImage',
                },
                {
                    description: 'DEB Package',
                    link: 'vde-dataset-viewer.' + currentVersion + '.deb',
                },
            ],
        };

        return (
            <div className={classes.root}>
                <AppBar position="relative" color='default'>
                    <Tabs
                        value={this.state.currentTab}
                        onChange={this.handleChange('currentTab')}
                        fullWidth
                        indicatorColor='primary'
                        textColor='primary'
                        scrollButtons="auto"
                    >
                        {tabNames.map(tab => {
                            return <Tab key={tab} label={tab} />;
                        })
                        }
                    </Tabs>
                </AppBar>
                <TabContainer padding>
                    {this.getDownloadsTable(
                        downloads[tabNames[this.state.currentTab]],
                        currentVersion
                    )}
                </TabContainer>
            </div>
        );
    }
}

VdeDatasetViewerDownloadsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    currentVersion: PropTypes.string.isRequired,
};

export default withStyles(styles)(VdeDatasetViewerDownloadsTable);